import { hasOwnProperty } from '@/utils/hasOwnProperty';
import { t } from '@/utils/i18n';
import { isObject } from '@/utils/isObject';
import { ErrorTypes } from './errorTypes';

const errorMapping = [
  {
    test: /smaller\sthan/,
    type: ErrorTypes.MIN_BOUND,
  },
  {
    test: /It is not allowed to enlarge/,
    type: ErrorTypes.DPI_BOUND,
  },
  {
    test: /HARD\sBOUNDARY/,
    type: ErrorTypes.HARD_BOUNDARY,
  },
  {
    // https://git.spreadomat.net/sprd/api-core-ng/blob/master/src/main/java/net/sprd/components/productmgmt/core/processors/validators/PrintAreaValidator.java
    // to big: independent print colors (e.g. flex)
    // too big: digital print types
    test: /is\stoo?\sbig\sfor\sprinttype/,
    type: ErrorTypes.MAX_BOUND,
  },
  {
    test: /blacklisted\sterm/,
    type: ErrorTypes.COPYRIGHT,
  },
  {
    test: /is\snot\sallowed\sabove/,
    type: ErrorTypes.CONFIGURATION_OVERLAP,
  },
  {
    test: /not\sallowed\sabove\scolor/,
    type: ErrorTypes.COLOR_OVERLAP,
  },
  {
    test: /unsupported\sunicode\scharacter/,
    type: ErrorTypes.UNSUPPORTED_UNICODE,
  },
];

export const getProductSavingMessage = (error: unknown) => {
  const errorMessage =
    (isObject(error) && hasOwnProperty(error, 'message') && String(error.message)) || '';
  const match = errorMapping.find((e) => e.test.test(errorMessage));
  const errorType = (match && match.type) || ErrorTypes.UNKNOWN;
  let parsedErrorMessage;

  switch (errorType) {
    case ErrorTypes.COPYRIGHT:
      const matchBlockedTerm = /\[(.*?)]!$/.exec(errorMessage);
      const blockedTerm = matchBlockedTerm?.[1] || '';
      parsedErrorMessage = t('error.copyrightError', blockedTerm, blockedTerm);
      break;
    case ErrorTypes.UNSUPPORTED_UNICODE:
      const matchUnsupportedSymbol = /was: '(.*?)'/.exec(errorMessage);
      parsedErrorMessage = t('error.unicode', matchUnsupportedSymbol?.[1] || '');
      break;
    default:
      parsedErrorMessage = t(`productCreationError.${errorType}`);
  }

  return [parsedErrorMessage || t('error.defaultError'), errorType] as const;
};
